import { Fill, Row, Style } from 'exceljs';

export interface XlsxWriter {
    writeRow: <T>(row: T[], cb?: (row: Row) => void) => Promise<void> | void;
    close: (encoding: BufferEncoding) => Promise<string | void>;
    writeColumns: (
        columns: { header: string; key: string; width: number }[],
        setStyles?: (row: Row, defaultCellStyle: Partial<Style>, defaultCellFill: Fill) => void,
    ) => void;
}
